export const SUBJECT_LEVEL_CHANGE = 'SUBJECT_LEVEL_CHANGE';

export const setSubjectsLevels = (type, value) => dispatch => {
    dispatch({
        type: SUBJECT_LEVEL_CHANGE,
        data: { type: type, value: value }
    })
};
